export const capitalizeFirstLetter = (input: string) => {
    if (input.length === 0) return input;

    return input.charAt(0).toUpperCase() + input.slice(1);
}

export const getNotEmpty = (input?: string) => {
    const text = input?.trim();
    return text?.length ? text : null;
}